import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Input } from '../../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../../shared/http-client';
import { FormFooter } from '../../../../elements/form-footer';
import { FieldError } from "../../../../elements/field-error/field-error";
import { Select } from '../../../../elements/select';
import { DatePicker } from '../../../../elements/date-picker';
import { DateTimePicker } from '../../../../elements/date-time-picker';
import { TextArea } from '../../../../elements/text-area';
import { RadioGroup } from '../../../../elements/radio-group';
import { FileInputElement } from '../../../../elements/file-input';


// construccion del objecto yup de validacion del cuestionario




export const MultasTabForm = ({
    item,
    exp,
    close,
    doDelete
}: {
    item?: any;
    exp?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [vehicles, setVehicles] = useState<any | null>([]);
    const [tiposMultas, setTiposMultas] = useState<any | null>([]);
    const [estadosMultas, setEstadosMultas] = useState<any | null>([]);

    const [date, setDate] = useState<string>(item ? data?.date : dayjs().format('YYYY-MM-DDTHH:mm:ss'));
    const [isDeleted, setIsDeleted] = useState<boolean>(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setDate(value);

    };


    useEffect(() => {
        api('/fleet/vehicles/?limit=9999', 'GET');
    }, []);


    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const initialValues = {
        vehicle: '',
        driver: id,
        date: '',
        location: '',
        amount: '',
        state: null,
        type: null,
        payment_due_date: '',
        issuing_entity: ''


    };

    let obligado = {
        vehicle: Yup.string().required('obligatorio'),
        location: Yup.string().required('obligatorio'),
        //status: Yup.mixed().required('obligatorio'),
        //amount: Yup.string().required('obligatorio'),
        payment_due_date: Yup.mixed().required('obligatorio'),
        issuing_entity: Yup.string().required('obligatorio'),
        state: Yup.mixed().required('obligatorio'),
        type: Yup.mixed().required('obligatorio'),



    };

    const validacion = Yup.object().shape(obligado);

    const openInNewTab = () => {
        window.open(data?.display_url, '_blank', 'noreferrer');
    };


    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        const formattedDate = date ? new Date(date).toISOString().slice(0, 16) : "";

        after.date = formattedDate || data?.date;

        if (id) {
            after.driver = id;
        }

        delete after.name;

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);

        let formdata = new FormData();

        if (enviaremos.document) {
            if (enviaremos.document.document) {
                formdata.append(
                    'document',
                    enviaremos.document.document[0],
                    enviaremos.document.document[0].name
                );
            }
        }


        for (let key in enviaremos) {
            if (key !== 'document') {
                formdata.append(key, enviaremos[key] ? enviaremos[key] : "");
            }
        }

        if (isDeleted) {
            api(`/fleet/sanctions/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            if (enviaremos.id) {
                // update

                api(`/fleet/sanctions/${enviaremos.id}/`, 'PATCH', formdata, true);
            } else {
                // create

                api('/fleet/sanctions/', 'POST', formdata, true);
            }
        }
    };

    const addNameToObjects = (arr: { plate: string }[]): { plate: string; name: string }[] => {
        return arr.map(obj => ({ ...obj, name: obj.plate }));
    };

    useEffect(() => {

        if (state.data) {

            if (state.path.includes('vehicles')) {

                setVehicles(addNameToObjects(state.data.results));
                api('/fleet/sanction-types/?limit=9999', 'GET');
            }

            if (state.path.includes('sanction-types')) {

                setTiposMultas(state.data.results);
                api('/fleet/sanction-states/?limit=9999', 'GET');

            }

            if (state.path.includes('sanction-states')) {

                setEstadosMultas(state.data.results);

            }

            if (state.path.includes('sanctions')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    window.location.reload();
                    close();
                }
            }
        }

        if (state.error) {
            toast.error('Server Error');
        }
    }, [state]);

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={data || initialValues}
                validationSchema={validacion}
                validateOnBlur={true}
                onSubmit={onSubmit}
            >
                {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className="flex">
                            <div className="w-full">
                                <div className="my-[11px] w-full">
                                    <Select
                                        name="vehicle"
                                        label={t('common.label.vehiculo')}
                                        placeholder="Select"
                                        items={vehicles}
                                        value={values.vehicle}
                                        onChange={(value) => {
                                            setFieldValue('vehicle', value.vehicle);
                                        }}
                                    />
                                    <FieldError touched={touched} errors={errors} field={"vehicle"} />


                                    {/* --------------------FECHA------------------- */}

                                    <label className="block text-sm font-semibold leading-6 text-gray-700">
                                        {t('common.labels.date')}
                                    </label>
                                    <input
                                        id="dateInput"
                                        type="datetime-local"
                                        step="1" // Permite solo minutos (sin segundos)
                                        value={date || data?.date} // Mostrar sin segundos en el input
                                        onChange={handleChange}
                                    />

                                    <FieldError touched={touched} errors={errors} field={"date"} />
                                    {/* --------------------FECHA------------------- */}

                                    {/* --------------------FECHA------------------- */}

                                    <div className='pt-4'>
                                        <DatePicker
                                            name="payment_due_date"
                                            type="date"
                                            label={t(
                                                'common.label.fecha-limite-pago'
                                            )}
                                            value={
                                                (data
                                                    ? dayjs(
                                                        data.payment_due_date
                                                    ).format(
                                                        'YYYY-MM-DD'
                                                    )
                                                    : '') ||
                                                values.payment_due_date
                                            }
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'payment_due_date',
                                                    value.payment_due_date
                                                        ? dayjs(
                                                            value.payment_due_date
                                                        ).format(
                                                            'YYYY-MM-DD'
                                                        )
                                                        : null
                                                );
                                            }}
                                        />
                                    </div>



                                    <FieldError touched={touched} errors={errors} field={"payment_due_date"} />
                                    {/* --------------------FECHA------------------- */}

                                    <div className='pt-4'>
                                        <Input
                                            label={t('common.label.ubicacion')}
                                            type="text"
                                            placeholder={t('common.label.ubicacion')}
                                            name="location"
                                            value={values.location}
                                            onChange={(value) =>
                                                setFieldValue('location', value.location)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'location'}
                                        />
                                    </div>


                                    <div>
                                        <TextArea
                                            label={t(
                                                'common.label.observaciones'
                                            )}
                                            placeholder={t(
                                                'common.label.observaciones'
                                            )}
                                            name="observations"
                                            value={values.observations}
                                            onChange={(value: any) =>
                                                setFieldValue(
                                                    'observations',
                                                    value.observations
                                                )
                                            }
                                        />
                                    </div>
                                    <div>
                                        <Input
                                            label={t('common.form-label.importe')}
                                            type="number"
                                            placeholder={t('common.form-label.importe')}
                                            name="amount"
                                            value={values.amount}
                                            onChange={(value) =>
                                                setFieldValue('amount', value.amount)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'amount'}
                                        />
                                    </div>
                                    <div className='w-full'>
                                        <div className='pt-4'>
                                            {data?.document ? <div className='flex'>
                                                {!isDeleted ? <div className='flex cursor-pointer' onClick={openInNewTab}>
                                                    <span className='border border-gray-400 rounded py-2 px-4 text-sm'>{t('common.label.ver-document')}</span>
                                                </div> : ''}
                                                {!isDeleted ? <div className='flex cursor-pointer ml-8' onClick={() => {
                                                    setFieldValue('document', null);
                                                    setFieldValue('display_url', null);
                                                    setIsDeleted(true);
                                                }}>
                                                    <span className='border border-red-500 rounded p-2 text-sm text-red-500'>{t('common.button.delete-document')}</span>
                                                </div> : ''}
                                            </div> : ''
                                            }
                                        </div>
                                        <div className='w-full pt-4'>
                                            {id ? <span className="block text-sm font-semibold leading-6 text-gray-700">{data?.document ? t('common.label.cambiar-document') : t('common.form-label.documento')}</span> : ''}
                                            <FileInputElement
                                                name="document"
                                                accept={'image/png, image/jpeg, , application/pdf'}
                                                onChange={(value) => {
                                                    // Extraemos directamente el FileList del objeto que retorna el FileInputElement
                                                    setFieldValue('document', value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className='pt-4'>
                                        <Input
                                            label={t('common.label.entidad-emisora')}
                                            type="text"
                                            placeholder={t('common.label.entidad-emisora')}
                                            name="issuing_entity"
                                            value={values.issuing_entity}
                                            onChange={(value) =>
                                                setFieldValue('issuing_entity', value.issuing_entity)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'issuing_entity'}
                                        />
                                    </div>

                                    <Select
                                        name="state"
                                        label={t('common.label.estados-multa')}
                                        placeholder="Select"
                                        items={estadosMultas}
                                        value={values.state}
                                        onChange={(value) => {
                                            setFieldValue('state', value.state);
                                        }}
                                    />
                                    <FieldError touched={touched} errors={errors} field={"state"} />


                                    <Select
                                        name="type"
                                        label={t('common.label.tipos-multa')}
                                        placeholder="Select"
                                        items={tiposMultas}
                                        value={values.type}
                                        onChange={(value) => {
                                            setFieldValue('type', value.type);
                                        }}
                                    />
                                    <FieldError touched={touched} errors={errors} field={"type"} />

                                </div>

                            </div>
                        </div>
                        <div className='h-24'></div>

                        <FormFooter
                            item={item}
                            doDelete={doDelete}
                            doSubmit={handleSubmit}
                            close={close}
                        />
                    </form>
                )}
            </Formik>
        </div>
    );
};